<div class="project-profile-card" [ngClass]="{
  'project-profile-card--setup': isSetupState(),
  'project-profile-card--help': isHelpState()
}">
  @if (hasProject()) {
    <!-- Scenario 1: Active Project -->
    <div class="project-profile-card__header">
      <img [src]="resolvedCoverPhoto()" alt="Project background" class="project-profile-card__background" />
      @if (showStatus()) {
        <div class="project-profile-card__status project-profile-card__status--{{ status() | lowercase }}">
          <p>{{ status() | lowercase }}</p>
        </div>
      }
    </div>

    <div class="project-profile-card__content">
      <div class="project-profile-card__title">{{ projectName() }}</div>
      <p class="project-profile-card__description">{{ projectDescription() }}</p>
      <button class="project-profile-card__button" (click)="onButtonClick()">
        {{ buttonTextKey() | translateLang }}
      </button>
    </div>
  } @else if (isSetupState()) {
    <!-- Scenario 2: Setup State (No Project) -->
    <div class="project-profile-card__header project-profile-card__header--setup">
      <div class="project-profile-card__icon-container">
        <div class="project-profile-card__icon" [innerHTML]="getSafeIcon()"></div>
      </div>
      <div class="project-profile-card__header-text">
        <div class="project-profile-card__title project-profile-card__title--setup">
          {{ setupTitleKey() | translateLang }}
        </div>
        <p class="project-profile-card__subtitle">
          {{ setupSubtitleKey() | translateLang }}
        </p>
      </div>
    </div>

    <div class="project-profile-card__content">
      <p class="project-profile-card__message">{{ setupMessageKey() | translateLang }}</p>
      <button class="project-profile-card__button" (click)="onButtonClick()">
        {{ setupActionKey() | translateLang }}
      </button>
    </div>
  } @else if (isHelpState()) {
    <!-- Scenario 3: Help Card -->
    <div class="project-profile-card__header project-profile-card__header--help">
      <div class="project-profile-card__help-row">
        <div class="project-profile-card__icon-container">
          <div class="project-profile-card__icon" [innerHTML]="getSafeIcon()"></div>
        </div>
        <div class="project-profile-card__header-text">
          <div class="project-profile-card__title project-profile-card__title--help">
            {{ helpTitleKey() | translateLang }}
          </div>
          <p class="project-profile-card__subtitle">
            {{ helpMessageKey() | translateLang }}
          </p>
        </div>
      </div>
      <button class="project-profile-card__button" (click)="onButtonClick()">
        {{ helpActionKey() | translateLang }}
      </button>
    </div>
  }
</div>
